export const FREE = "free";
export const BUSY = "busy";
export const PAUSED = "paused";
